import { api } from "../../common/config/api";

export const AVAILABILITY_URL = {
   getAvailabilitys: `${api.withAPI}/v1/availabilityNotification`,
   removeAvailability: `${api.withAPI}/v1/availabilityNotification`
}
